import Petition from './Petition';

const Utils = {
    Petition
}
export default Utils;